import type { AssetLocation } from "@amzn/d16-g-client-deck-builder-typescript-client";
import { InsightType } from "@amzn/d16-g-client-deck-builder-typescript-client";

import { zustandStore } from "../store/zustand.helpers";

export enum SfObjectType {
    OPPORTUNITY = "OPPORTUNITY",
    ACTIVITY = "ACTIVITY",
}

export type SfObject = {
    sfObjectType: SfObjectType;
    sfObjectId: string;
};

export interface InsightLinkageMetadata {
    title: string;
    content?: AssetLocation;
    insightType: InsightType;
    identifier: string;
    downloadUrl?: string;
    description: string;
    contentId?: string;
    contentVersion?: string;
}

export type InsightLinkageState = {
    open: boolean;
    insightLinkageMetadata: InsightLinkageMetadata;
    sfObject: SfObject;
};

export interface InsightLinkageActions {
    setInsightLinkageMetadata: (
        insightLinkageMetadata: InsightLinkageMetadata,
    ) => void;
    setOpen: (open: boolean) => void;
    setSfObject: (sfObject: SfObject) => void;
    resetInsightLinkage: () => void;
}

export const initialState: InsightLinkageState = {
    open: false,
    insightLinkageMetadata: {
        title: "",
        insightType: InsightType.IHUB,
        identifier: "",
        description: "",
    },
    sfObject: {
        sfObjectType: SfObjectType.OPPORTUNITY,
        sfObjectId: "",
    },
};

export const { store: InsightLinkageStore } = zustandStore<
    InsightLinkageState,
    InsightLinkageActions
>("InsightLinkage", initialState, (set: any) => ({
    setOpen: (open) => set(() => ({ open })),
    setSfObject: (sfObject) => set(() => ({ sfObject })),
    setInsightLinkageMetadata: (
        insightLinkageMetadata: InsightLinkageMetadata,
    ) => set(() => ({ insightLinkageMetadata })),
    resetInsightLinkage: () =>
        set(() => {
            return { ...initialState };
        }),
}));
